import React from 'react';

function Plus(props: any) {
    return (
        <svg
            className={props.className}
            height={props.height}
            width={props.width}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
            <path
                fill={props.fill}
                d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z"
            />
        </svg>
    );
}

export default Plus;
